(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-footer"]) return;
  try {
    
  const rrOpenShipping = () => { const panel = document.getElementById('shipping'); if (panel) panel.open = true; };
  document.addEventListener('click', event => { if (event.target.closest('[data-rr-shipping]')) rrOpenShipping(); });
  if (window.location.hash === '#shipping') rrOpenShipping();
  window.addEventListener('hashchange', () => { if (window.location.hash === '#shipping') rrOpenShipping(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-navigation"]) return;
  try {
    
  (() => {
    if (window.rrGalleryBound) return;
    window.rrGalleryBound = true;
    const choose = (handle) => {
      const dialog = document.getElementById('rr-art-dialog');
      if (!dialog) return;
      const panels = Array.from(dialog.querySelectorAll('[data-rr-art]'));
      const active = panels.find(panel => panel.dataset.rrArt === handle) || panels[0];
      if (!active) return;
      panels.forEach(panel => { panel.hidden = panel !== active; });
      dialog.querySelector('select').value = active.dataset.rrArt;
      return dialog;
    };
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-rr-open]');
      if (opener) {
        event.preventDefault();
        document.querySelectorAll('.rr-mobile-nav[open]').forEach(menu => { menu.open = false; });
        const dialog = choose(opener.dataset.rrOpen);
        if (dialog && !dialog.open) dialog.showModal();
        if (dialog) history.replaceState(null, '', '#art-' + dialog.querySelector('select').value);
      }
      if (event.target.closest('[data-rr-close]')) document.getElementById('rr-art-dialog')?.close();
      const enquiry = event.target.closest('[data-rr-enquire]');
      if (enquiry) {
        document.getElementById('rr-art-dialog')?.close();
        const field = document.getElementById('rr-enquiry-artwork');
        if (field) {
          event.preventDefault();
          field.value = enquiry.dataset.rrEnquire;
          document.getElementById('contact').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          field.focus({ preventScroll: true });
        }
      }
      if (event.target.closest('.rr-mobile-nav nav a')) document.querySelector('.rr-mobile-nav').open = false;
      const viewButton = event.target.closest('[data-rr-image-mode]');
      if (viewButton) {
        const visual = viewButton.closest('.rr-art-visual');
        visual.querySelectorAll('[data-rr-image-mode]').forEach(button => button.setAttribute('aria-pressed', String(button === viewButton)));
        visual.querySelectorAll('[data-rr-image]').forEach(figure => { figure.hidden = figure.dataset.rrImage !== viewButton.dataset.rrImageMode; });
      }
      const step = event.target.closest('[data-rr-gallery-step]');
      if (step) {
        const hero = step.closest('.rr-gallery');
        const slides = Array.from(hero.querySelectorAll('.rr-mobile-slide'));
        const next = ((Number(hero.dataset.active || 0) + Number(step.dataset.rrGalleryStep)) % slides.length + slides.length) % slides.length;
        hero.dataset.active = next;
        slides.forEach((slide, index) => { slide.hidden = index !== next; });
        hero.querySelector('[data-rr-counter]').textContent = String(next + 1).padStart(2, '0') + ' / 03';
      }
    });
    document.addEventListener('change', event => { if (event.target.id === 'rr-art-choice') { choose(event.target.value); history.replaceState(null, '', '#art-' + event.target.value); } });
    const hashArtwork = location.hash.startsWith('#art-') ? location.hash.slice(5) : '';
    if (hashArtwork) { const dialog = choose(hashArtwork); if (dialog && !dialog.open) dialog.showModal(); }
    document.addEventListener('close', event => { if (event.target.id === 'rr-art-dialog' && location.hash.startsWith('#art-')) history.replaceState(null, '', location.pathname + location.search); }, true);
    document.addEventListener('shopify:block:select', event => {
      const panel = event.target.closest('[data-rr-art]');
      if (!panel) return;
      const dialog = choose(panel.dataset.rrArt);
      if (dialog && !dialog.open) dialog.showModal();
    });
    document.addEventListener('shopify:section:unload', () => document.getElementById('rr-art-dialog')?.close());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-product"]) return;
  try {
    
  const rrInitPurchase = (scope = document) => { scope.querySelectorAll('[data-rr-purchase]').forEach(root => {
    if (root.dataset.rrBound) return;
    root.dataset.rrBound = 'true';
    const data = JSON.parse(root.querySelector('[data-rr-variants]').textContent);
    root.addEventListener('change', event => {
      if (!event.target.matches('input[type="radio"]')) return;
      const options = Array.from(root.querySelectorAll('[data-option-index]')).map(group => group.querySelector('input:checked')?.value);
      const variant = data.variants.find(item => item.options.every((value, index) => value === options[index]));
      root.querySelector('input[name="id"]').value = variant?.id || '';
      root.querySelector('[data-rr-price]').textContent = variant?.money || '';
      root.querySelector('[data-rr-variant-status]').textContent = !variant ? data.unavailable : variant.available ? '' : data.soldOut;
      root.querySelector('[data-rr-add]').disabled = !variant?.available;
      const enquiry = root.closest('.rr-product-copy').querySelector('[data-rr-enquire]');
      if (enquiry) { enquiry.dataset.rrEnquire = root.closest('.rr-product-copy').querySelector('h1').textContent + ' - ' + options.join(' / '); }
      const visual = root.closest('.rr-product-grid').querySelector('.rr-art-visual');
      if (event.target.value === 'Print Only' || event.target.value === 'Framed') {
      const imageMode = options.includes('Print Only') ? 'original' : 'framed';
      visual.querySelectorAll('[data-rr-image-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rrImageMode === imageMode)));
      visual.querySelectorAll('[data-rr-image]').forEach(figure => { figure.hidden = figure.dataset.rrImage !== imageMode; });
      }
      if (variant) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url); }
    });
  }); };
  rrInitPurchase();
  document.addEventListener('shopify:section:load', event => rrInitPurchase(event.target));

  } catch(e) { console.error(e); }
})();
})();
